import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from 'antd'
import { FileOutlined } from '@ant-design/icons'
import { useBackend } from '../../../services/backend'
import { notificationAction } from '../../../redux/middleware/actions'
import { Loading } from '../../../components/Misc/Loading'
import { User } from '../../../types/user/User'
import SuperUserUserTable from './components/SuperUserUserTable'
import { autoDownload } from '../../../utils/helpers'
import { AppDispatch } from '../../../redux/store'

const SuperUserUsers: React.FC = () => {
  const getRequest = useBackend(`/api/superuser/users`)
  const { loading } = getRequest
  const dispatch: AppDispatch = useDispatch()

  const [users, setUsers] = useState<User[]>([])
  const contentEl = useRef(null)

  const getCSVRequest = useBackend(`/api/superuser/users/csv`, process.env.REACT_APP_BACKEND_URL, 'arraybuffer')

  const downloadCSV = async () => {
    try {
      const response = await getCSVRequest.get({})

      autoDownload(`users.csv`, response)
    } catch (error) {
      dispatch(notificationAction({ type: 'error', message: 'DOWNLOAD_ERROR' }))
    }
  }

  const request = (params?: any) => {
    getRequest
      .get({ body: { params } })
      .then(setUsers)
      .catch((e: any) => {
        dispatch(
          notificationAction({
            type: 'error',
            message: 'USERS_ERROR',
            description: e.message
          })
        )
      })
  }

  useEffect(request, [])

  return (
    <>
      <Button key="csv" icon={<FileOutlined />} onClick={downloadCSV}>
        CSV
      </Button>
      <div ref={contentEl}>{loading ? <Loading /> : <SuperUserUserTable users={users} />}</div>
    </>
  )
}

export default SuperUserUsers
